import axiosInstance from './axiosInstance';

const createReward = (data) =>
  axiosInstance.post('/internal/admin/rewards', data);

export default createReward;
